module.exports = __webpack_public_path__ + "static/media/gaming.308bea22.jpg";